var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowspecDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "1em",
    viewBox: "0 0 86 54",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "flowspec-dark_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 43,
    x2: 43,
    y1: 0,
    y2: 54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.52
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.161 34.075L59.776 0H25.932L8.355 17.527 0 9.303v33.025h33.549zm27.29-22.408l8.384 8.258L26.224 54h33.844l17.577-17.527L86 44.697v-33.03z",
    fill: "url(#flowspec-dark_svg__a)"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjU0IiB2aWV3Qm94PSIwIDAgODYgNTQiIHdpZHRoPSI4NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGxpbmVhckdyYWRpZW50IGlkPSJhIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjQzIiB4Mj0iNDMiIHkxPSIwIiB5Mj0iNTQiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmZiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIuNTIiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Im0yNS4xNjEzIDM0LjA3NTIgMzQuNjE1Mi0zNC4wNzUyaC0zMy44NDQ3bC0xNy41NzY2OSAxNy41Mjc1LTguMzU1MTEtOC4yMjQ3NnYzMy4wMjU3NmgzMy41NDl6bTI3LjI4OTEtMjIuNDA3OSA4LjM4NDYgOC4yNTc1LTM0LjYxMTUgMzQuMDc1MmgzMy44NDQ3bDE3LjU3NjctMTcuNTI3NSA4LjM1NTEgOC4yMjQ4di0zMy4wMjk1eiIgZmlsbD0idXJsKCNhKSIvPjwvc3ZnPg==";
export { SvgFlowspecDark as ReactComponent };